import React from "react";
import {
  Avatar,
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CommonButton from "../../components/common/Button";
import { CloseIcon } from "../../helper/Icons";

const History_modal = ({ handleClose, modalOpen }) => {

  return (
    <>
      <DialogTitle sx={{ m: 0, p: 2 }} id="Common_modal">
        History
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{minWidth:{xs:'100%',sm:'500px'}}}>
        <Grid container spacing={2}>
          <Grid xs={12} item  >
            <Typography variant="h6">User Name</Typography>
            <Typography variant="body1"> Nilesh Gogdani</Typography>
          </Grid>
    
          <Grid xs={12} sm={6} item>
            <Typography variant="h6">Email</Typography>
            <Typography variant="body1">xxxxxx</Typography>
          </Grid>
          <Grid xs={12} sm={6} item>
            <Typography variant="h6">Mobile Number</Typography>
            <Typography variant="body1">+91 122</Typography>
          </Grid>
         
        </Grid>
      </DialogContent>
      <DialogActions>
        <CommonButton
          buttonName={"Close"}
          size="small"
          color="white"
          onClick={handleClose}
        />
      </DialogActions>
    </>
  );
};

export default History_modal;
